<template>
  <div class="searchSort">
    <div class="sort">
      <div class="timer cpn"
           :class="active == 0 ? 'active' : ''"
           @click="handleClick('0', 'timer')"      
      >
        时间
        <span class="cpnSpan"
              :class="active == 0 ? '' : 'priceCss'"
              :style="`background-position: 0 ${priceImg}px;background-repeat:no-repeat;`"
        ></span>
      </div>
      <div class="price cpn"
           :class="active == 1 ? 'active' : ''"
           @click="handleClick('1', 'price')"
      >
        价格
        <span class="cpnSpan"
              :class="active == 1 ? '' : 'timeCss'"
              :style="`background-position: 0 ${timeImg}px;background-repeat:no-repeat;`"
        ></span>
      </div>
    </div>
    <div class="pages">
      <div style="margin-right:20px;">共<span style="color:#cc0000;">{{sortList.auction_total}}</span>件拍品</div>
      <div style="margin-right:10px;">
        <span style="color:#cc0000;">{{totalCurrent}}</span>
        /
        <span>{{sortList.pages}}</span>
      </div>
      <div class="control">
        <span :class="totalCurrent == '1' ? 'nounable' : ''">
          <span style="background:#efefef;color:#d4d4d4;"
              :class="totalCurrent == '1' ? 'unable' : ''"
              @click="clickPages(1)"
          > &lt; </span>
        </span>
        <span :class="totalCurrent == '1' ? 'nounable' : ''">
          <span style="background:#000000;color:#fff;"
                :class="totalCurrent == '1' ? 'unable' : ''"
                @click="clickPages('subtract')"
          > &lt; </span>
        </span>

        <span :class="totalCurrent == sortList.pages ? 'nounable' : ''">
          <span style="background:#000000;color:#fff;"
              :class="totalCurrent == sortList.pages ? 'unable' : ''"
              @click="clickPages('add')"
          > &gt; </span>
        </span>
        
        <span :class="totalCurrent == sortList.pages ? 'nounable' : ''">
          <span style="background:#efefef;color:#d4d4d4;"
                :class="totalCurrent == sortList.pages ? 'unable' : ''"
                @click="clickPages(sortList.pages)"
          > &gt; </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'searchSort',
    props: ['sortList','totalCurrent'],
    data() {
      return {
        active: 0,
        price: 1,
        priceImg: 12.5,
        time: 6,
        timeImg: 12.5
      }
    },
    methods: {
      handleClick(active, item) {
        this.active = active;
        if(active == '0'){
          if(this.price == 1) {
            this.price = 2
            this.priceImg = -16
          }else {
            this.price = 1
            this.priceImg = 12.5
          }
          this.$emit('handleSort', this.price)
        }else{
          if(this.time == 6) {
            this.time = 7
            this.timeImg = -16
          }else {
            this.time = 6
            this.timeImg = 12.5
          }
          this.$emit('handleSort', this.time)
        }
      },
      clickPages(page) {
        switch(page) {
          case 1:
            this.$emit('handlePages', 1)
            break;
          case this.sortList.pages:
            this.$emit('handlePages', this.sortList.pages)
            break;
          case 'subtract':
            this.$emit('handlePages', this.totalCurrent - 1)
            break;
          case 'add':
            this.$emit('handlePages', parseInt(this.totalCurrent) + 1)
            break;
          default:
            break;
        }
        console.log('跳转页数', page);
      }
    }
  }
</script>

<style lang="scss" scoped>
.searchSort {
  display: flex;
  justify-content: space-between;
  width: 680px;
  .sort {
    display: flex;
    .active {
      background-color: #000000;
      color: #fff;
    }
    .cpn {
      text-align: center;
      width: 80px;
      line-height: 25px;
      cursor: pointer;
      &:hover {
        color: #5bb2e4;
      }
      .cpnSpan {
        display: inline-block;
        height: 25px;
        width: 9px;
        background-image: url(~@/assets/imgs/old/price.png) ;
        z-index: 2;
      }
    }
  }
  .pages {
    display: flex;
    line-height: 32px;
    .control {
      span {
        display: inline-block;
        width: 25px;
        cursor: pointer;
        text-align: center;
      }
    }
  }
}
.timeCss, .priceCss {
  visibility: hidden;
}
.nounable {
  cursor: not-allowed !important;
}
.unable {
  pointer-events:none;
}
</style>